import React from "react";
import { useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";

export const withSelectedField = (Component) => {
  return (props) => {
    const { selectedFieldId, templateFields } = useSelector(
      (state: ReduxState) => state.TemplateField
    );
    const maybeField = templateFields.filter((tf) => tf.id === selectedFieldId);
    if (maybeField.length === 0) {
      return null;
    }

    const field = maybeField[0];
    return <Component field={field} {...props} />;
  };
};
